export const config = {
  BASE_URI: import.meta.env.VITE_BASE_URL,
  BASE_URL_VISIT_ENGINE: import.meta.env.VITE_BASE_URL_VISIT_ENGINE,
  SSO_AUTHORIZE_URL: import.meta.env.VITE_SSO_AUTHORIZE_URL,
  SSO_CLIENT_ID: import.meta.env.VITE_SSO_CLIENT_ID,
  SSO_REDIRECT_URI: import.meta.env.VITE_SSO_REDIRECT_URI,
  SSO_SCOPE: import.meta.env.VITE_SSO_SCOPE ?? 'openid profile',
  SSO_LOGOUT_URL: import.meta.env.VITE_SSO_LOGOUT_URL,
}
